define('uikit/extra/input.change.tracker',['require','exports','module','underscore','jquery'],function(require, exports, module){
  var _ = require('underscore');
  var $ = require('jquery');

  function InputChangeTracker(input) {
    this.$input = $(input);
    this.input = this.$input.get(0);
    this.startIndex = this.inputSelectionStart();
    this.startLength = this.inputValue().length;
  };

  _.extend(InputChangeTracker.prototype, {

    inputSelectionStart: function() {
      return this.input.selectionStart;
    },

    value: function() {
      var value      = this.inputValue(),
          startIndex = this.startIndex,
          endIndex   = startIndex + value.length - this.startLength;

      return startIndex > -1 ? value.slice(startIndex, endIndex) : '';
    },

    inputValue: function() {
      return this.$input.val();
    },

    leftValue: function(offset) {
      offset = offset || 0;
      return this.inputValue().slice(0, this.startIndex-offset)
    },

    rightValue: function(offset) {
      var currentvalue = this.value();
      offset = offset || 0;
      return this.inputValue().slice(this.startIndex + currentvalue.length - offset);
    }

  });
  
  module.exports = InputChangeTracker;
});
